import { OutlineButton } from '@chegg-ui/button'
import { ForwardIcon } from '@chegg-ui/theme'
import { Tooltip } from '@chegg-ui/tooltip'
import { ListItem } from '@src/components/base/List'
import { openExternalLink } from '@src/state/document/actions'
import media from '@src/styled/media'
import { Citation } from '@src/types/checks'
import { VISIT_SOURCE_BUTTON } from '@src/utils/dataTestIds'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import styled from 'styled-components'
import TooltipContents from './TooltipContents'

const TextContainer = styled.div`
  flex: 0 0 auto;
  max-width: 350px;
  overflow-wrap: break-word;
  padding-right: 20px;
`

const SourceLink = styled.a`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.link};
  cursor: pointer;

  svg {
    fill: ${({ theme }) => theme.colors.link};
  }
`

const FlexListItem = styled(ListItem)`
  display: flex;
  justify-content: space-between;
  width: 520px;

  ${media.phone`
    flex-direction: column;
    width: 90vw;
  `}
`

export const PLAGIARISM_LINK_SOURCE: string = 'plagiarism link out'

const Button = styled(OutlineButton)`
  margin: 0 0 63px 0;
  width: auto;
  padding-left: 30px;
  padding-right: 30px;
  flex-shrink: 0;
  ${({ theme }) => media.phone`
    max-width: 70vw;
    margin-top: ${theme.spacing.sm};
  `}
`

const StyledForwardIcon = styled(ForwardIcon)`
  height: 30px;
  width: 30px;
  margin: 0 0 5px;
  vertical-align: middle;
`

interface DispatchProps {
  openSource: (source: string) => void
}

export const VISIT_SOURCE = 'Visit source'

interface PlagiarismProps extends Pick<Citation, 'source' | 'matched'> {}

type Props = PlagiarismProps & DispatchProps

export const DEFAULT_TOOLTIP_MSG = 'We found this text in our plagiarism check'

export const PlagiarismSource: React.FunctionComponent<Props> = ({
  source,
  matched,
  openSource,
}) => {
  const onClick = () => openSource(source)

  return (
    <FlexListItem>
      <Tooltip
        position="top"
        targetElement={
          <TextContainer>
            <SourceLink
              href={source}
              target="_blank"
              onClick={e => {
                e.preventDefault()
                onClick()
              }}
            >
              {source}
              <StyledForwardIcon />
            </SourceLink>
          </TextContainer>
        }
      >
        <TooltipContents matched={matched} tooltipText={DEFAULT_TOOLTIP_MSG} />
      </Tooltip>
      <Button onClick={onClick} data-test={VISIT_SOURCE_BUTTON}>
        {VISIT_SOURCE}
      </Button>
    </FlexListItem>
  )
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  openSource: (source: string) => {
    dispatch(openExternalLink({ source }, { source: PLAGIARISM_LINK_SOURCE }))
  },
})

export default connect<null, DispatchProps>(null, mapDispatchToProps)(PlagiarismSource)



// WEBPACK FOOTER //
// ./src/components/Modals/PlagiarismSourcesModal/PlagiarismSource.tsx